import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  handleApiError,
  setErrorToastDuration,
} from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { PulsaraConstants } from '../store/pulsara.constants'
import { PulsaraService } from '../services/pulsara.service'
import { IPulsaraAttachmentsRequest, IPulsaraAttachmentsResponse } from '../store/pulsara.types'
import { getPulsaraSelector } from '../selectors'
import i18n from '../../../i18n'
import { setLoading, setPulsaraAttachmentsList } from '../store/pulsara.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { isOffline } from '../../../utilities'
import { setErrorMessage, showToast } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import Logger from '../../../services/logger.service'

export function* fetchPulsaraAttachments() {
  const { selectedPulsaraId, pulsaraDetails } = yield select(getPulsaraSelector)

  if (!selectedPulsaraId) {
    return
  }

  if (pulsaraDetails?.attachmentList?.length > 0) {
    return
  }

  if (isOffline()) {
    yield put(setErrorMessage(i18n.t('pulsara.errors.offline')))
    yield put(setErrorToastDuration(2000))
    yield put(showToast(true))
    return
  }

  const authenticationJwt: string = yield select(getAuthenticationJwtSelector)

  yield put(setLoading('attachments'))

  try {
    const pulsaraService = new PulsaraService(authenticationJwt)

    const request: IPulsaraAttachmentsRequest = {
      pulsaraId: selectedPulsaraId,
    }

    const response: IPulsaraAttachmentsResponse = yield call(
      [pulsaraService, pulsaraService.fetchPulsaraAttachments],
      request
    )

    if (response.status === 200) {
      const { attachmentList } = response.data

      yield put(setPulsaraAttachmentsList(attachmentList))
      Logger.info(`Pulsara: fetchPulsaraAttachments success, count: ${attachmentList?.length ?? 0}`)
    } else {
      response.failure = true
      if (response.messages?.length) {
        const index = response.messages.findIndex((x) => x.status === response.status)
        response.responseMessage = response.messages[index]?.message
      } else {
        response.responseMessage = i18n.t('pulsara.errors.fetchAttachments')
      }
      yield put(handleApiError(response))
    }
  } catch (e: any) {
    const cause = e.message ? e.message : 'unknown'
    const errorResponse = {
      status: null,
      messages: [
        {
          status: null,
          display: [
            { id: 3, name: 'Alert' },
            { id: 1, name: 'Log' },
          ],
          message: i18n.t('pulsara.errors.fetchAttachmentsFailed', { cause }),
        },
      ],
    }
    yield put(handleApiError(errorResponse))
  } finally {
    yield put(setLoading(null))
  }
}

export function* fetchPulsaraAttachmentsSaga() {
  yield takeLatest([PulsaraConstants.FETCH_PULSARA_ATTACHMENTS], performWithMutexHOG, fetchPulsaraAttachments)
}
